import React from "react";
import { useForm } from "react-hook-form";
import { authService } from "@shared/ui";
import {useNavigate, useSearchParams} from "react-router-dom";
import { useTranslation } from "react-i18next";

type FormValues = {
  password: string;
  confirmPassword: string;
};

const ResetPasswordForm: React.FC = () => {
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm<FormValues>();

  const password = watch("password");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const token = searchParams.get("token");
  const userId = searchParams.has("user")? +(searchParams.get("user")!): null;

  const onSubmit = async (data: FormValues) => {
    if(token && userId) {
      authService.resetPassword(userId, data.password, data.confirmPassword, token)
          .then(data => {
            if(data){
              navigate("/login");
            }
          })
    }
  };

  return (
    <div className="form-page">
      <div className="form-wrapper">
        <h1 className="text-center">{t("resetPassword.title")}</h1>
    <form onSubmit={handleSubmit(onSubmit)}>
      <div>
        <label htmlFor="new-password">{t("resetPassword.labels.newPassword")}</label>
        <input
          id="new-password"
          type="password"
          {...register("password", {
            required: t("resetPassword.errors.passwordRequired"),
            minLength: {
              value: 6,
              message: t("resetPassword.errors.minLength"),
            },
          })}
        />
        {errors.password && <span className="error">{errors.password.message}</span>}
      </div>

      <div>
        <label htmlFor="password">{t("resetPassword.labels.confirmPassword")}</label>
        <input
          type="password"
          {...register("confirmPassword", {
            required: t("resetPassword.errors.confirmRequired"),
            validate: (value) =>
              value === password || t("resetPassword.errors.passwordsMismatch"),
          })}
        />
        {errors.confirmPassword && (
          <span className="error">{errors.confirmPassword.message}</span>
        )}
      </div>

      <input type="submit" disabled={isSubmitting} value={isSubmitting ? t("resetPassword.submit.saving") : t("resetPassword.submit.save")} />

    </form>
      </div>
    </div>
  );
};

export default ResetPasswordForm;